import * as ActionTypes from "../constants/actionTypes";

const initialState = {
    langCode: "EN",
    captchaB64Str: "",
    isCaptchaPass: false,
    isPublic: false,
    isFutures: false,
    refNo: ""
}

function edmReducer(state = initialState, action) {
    switch(action.type) {
        case ActionTypes.FETCH_CAPTCHA:
            return Object.assign({}, state, {
                captchaB64Str: action.payload
            });

        case ActionTypes.SUBMIT_EDM:
            return Object.assign({}, state, {
                isCaptchaPass: true,
                refNo: action.payload
            });

        case ActionTypes.FETCH_CHANNEL:
            return Object.assign({}, state, {
                isPublic: action.payload.channel === "public",
                isFutures: action.payload.channel === "f"
            });

        case ActionTypes.FETCH_CAPTCHA_CHECK:
            return Object.assign({}, state, {
                isCaptchaPass: action.payload
            });

        default:
            return state;
    }
}
export default edmReducer;